import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import { withCookies } from '@catalogo/core-connect/cookies';
import { withServicesPDP } from '@catalogo/service-americanas-product/src/hocs/services-pdp';
import { withMetrics } from '@catalogo/core-metrics';
import ServicesPDP from '@catalogo/ui-americanas-desktop-services-pdp';
import compose from 'lodash/fp/compose';
import BuyArea from './buy-area';
import SoldAndDelivered from './sold-and-delivered';
import MoreOffers from './more-offers';
import StockAlert from './stock-alert';
import InternationalMessage from './international-message';
import { Wrapper } from './wrapper';

export const OffersBox = props => {
  const {
    routeId,
    currentSku,
    product,
    page,
    variantB,
    experiment,
    selectQuantityWasUsed,
    servicesPDP,
    history,
  } = props;
  const offersQuantity = getIn(currentSku, ['offers', 'meta', 'total'], 0);
  const offer = getIn(currentSku, ['offers', 'result', '0']);
  const isO2O = getIn(currentSku, ['offers', 'result', 0, 'seller', 'id']) === '33014556000196';
  const isInternational = getIn(currentSku, ['offers', 'result', '0', 'currency']) === 'USD';
  const hasMoreOffers = offersQuantity > 1;

  if (!offer) {
    return null;
  }

  if (!hasMoreOffers && isO2O) {
    return (
      <Wrapper $variantB={variantB}>
        <ServicesPDP {...servicesPDP?.infoForComponent} />
        <BuyArea
          {...props}
          singleView
          currentSku={currentSku}
          offer={offer}
          page={page}
          product={product}
          experiment={experiment?.CAT_021_VARIACOES_SKU}
          discountProgressiveExperiment={props?.discountProgressiveExperiment}
          selectQuantityWasUsed={selectQuantityWasUsed}
          servicePDPinfoForWarranty={servicesPDP?.infoForWarranty}
          history={history}
        />
        <SoldAndDelivered routeId={routeId} currentSku={currentSku} isDigital={product?.isDigital} />
      </Wrapper>
    );
  }

  return (
    <Wrapper $variantB={variantB}>
      <StockAlert offer={offer} currentSku={currentSku} product={product} />
      <ServicesPDP {...servicesPDP?.infoForComponent} />
      <BuyArea
        currentSku={currentSku}
        offer={offer}
        page={page}
        product={product}
        experiment={experiment?.CAT_021_VARIACOES_SKU}
        selectQuantityWasUsed={selectQuantityWasUsed}
        servicePDPinfoForWarranty={servicesPDP?.infoForWarranty}
        history={history}
      />
      <SoldAndDelivered routeId={routeId} currentSku={currentSku} isDigital={product?.isDigital} />
      {isInternational && <InternationalMessage />}
      {hasMoreOffers && (
        <MoreOffersWrapper>
          <MoreOffers offersQuantity={offersQuantity - 1} currentSku={currentSku} product={product} />
        </MoreOffersWrapper>
      )}
    </Wrapper>
  );
};

const MoreOffersWrapper = styled.div`
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid rgba(206, 204, 204, 0.4);
`;

OffersBox.propTypes = {
  routeId: propTypes.string,
  currentSku: propTypes.object,
  cookies: propTypes.object,
  history: propTypes.object,
};

export default compose(withMetrics, withCookies, withServicesPDP)(OffersBox);
